import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { GOOGLE_ALERT_CARD_DEFS } from "./GoogleAdsTableConfig";

const GoogleAlertsPanel: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="paid-media-alerts">
      {GOOGLE_ALERT_CARD_DEFS.map(item => {
        const Icon = item.icon;
        return (
          <article className="google-ads-alert-card" key={item.titleKey}>
            <div className="google-ads-alert-card__icon">
              <Icon size={18} />
            </div>
            <div>
              <h3>{t(`googleAdsReport.alerts.${item.titleKey}`)}</h3>
              <p>{t(`googleAdsReport.alerts.${item.descKey}`)}</p>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default GoogleAlertsPanel;
